
var content = require("!!../../../node_modules/_css-loader@0.28.11@css-loader/index.js??ref--5-2!../../../node_modules/_postcss-loader@2.0.10@postcss-loader/lib/index.js??ref--5-3!../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js??ref--5-4!./sidebar.scss");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../node_modules/_style-loader@0.20.3@style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../node_modules/_css-loader@0.28.11@css-loader/index.js??ref--5-2!../../../node_modules/_postcss-loader@2.0.10@postcss-loader/lib/index.js??ref--5-3!../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js??ref--5-4!./sidebar.scss", function() {
		var newContent = require("!!../../../node_modules/_css-loader@0.28.11@css-loader/index.js??ref--5-2!../../../node_modules/_postcss-loader@2.0.10@postcss-loader/lib/index.js??ref--5-3!../../../node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js??ref--5-4!./sidebar.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./src/components/sidebar/sidebar.scss
// module id = ./src/components/sidebar/sidebar.scss
// module chunks = 3